import { useEffect, useRef } from 'react'

function useTimeout(callback: Function, ms: number) {
  const savedCallback = useRef<Function>();

  // Remember the latest callback
  useEffect(
    () => {
      savedCallback.current = callback
    },
    [callback]
  );

  // Set up the interval
  useEffect(
    () => {
        const delayed = ()=> {
          if(savedCallback.current) {
            savedCallback.current()
          }
        };
        const id = setTimeout(delayed, ms);
        return () => clearTimeout(id)
    },
    [ms]
  )
}

export default useTimeout;
